import { classNames } from "src/helpers/classNames";
import { useState, useEffect } from "react";

type Props = {
    activeTabKey: string;
    setActiveTabKey: (str: string) => void;
    actionID: any;
}

export default function Tabs(props: Props) {

    const { activeTabKey, setActiveTabKey } = props;

    const [tabs, setTabs] = useState<any>({
        card: { name: 'Карточка', href: '#' },
        comments: { name: 'Комментарии', href: '#' },
        history: { name: 'История', href: '#' }
    });

    return (
        <div className="px-[24px] sm:px-10 border-b border-gray-200 sticky sm:static top-[70px] sm:top-auto z-30 bg-white">
            <nav className="-mb-px flex space-x-[10px] sm:space-x-8">
                {Object.keys(tabs).map((key) => (
                    <>
                        {tabs[key] &&
                            <a
                                key={tabs[key].name}
                                href={tabs[key].href}
                                onClick={(e) => {
                                    e.preventDefault();
                                    let tabsTemp = { ...tabs };
                                    Object.keys(tabsTemp).map(innerKey => {
                                        tabsTemp = { ...tabsTemp, [innerKey]: { ...tabs[innerKey], current: false } }
                                    });
                                    setTabs((prevState: any) => {
                                        return { ...prevState, ...tabsTemp }
                                    });
                                    setActiveTabKey(key);
                                }}
                                className={classNames(
                                    key === activeTabKey
                                        ? 'border-[#012169] text-[#012169]'
                                        : 'border-transparent text-[#637381] hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'
                                )}
                            >
                                {tabs[key].name}
                            </a >
                        }
                    </>
                ))}
            </nav>
        </div >
    )
}
